import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

/**
 * Global state of the "New filings are unavailable" informational modal.
 * Opened by ErrorResponseInterceptor when the backend rejects an action
 * with 403 + tag `organization_filing_restricted`; rendered once at the app root.
 */
@Injectable({ providedIn: 'root' })
export class FilingRestrictedModalService {
  public readonly isOpen$: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  public open(): void {
    if (!this.isOpen$.value) {
      this.isOpen$.next(true);
    }
  }

  public close(): void {
    if (this.isOpen$.value) {
      this.isOpen$.next(false);
    }
  }
}
